import type {
  ProjectFeature,
  ProjectItem,
} from '@store/reducers/dashboard/types'
import type { TemplateItem } from '@store/reducers/templates'

// Only a template's own team may delete it; the Octopus gallery is read-only.
export const OWN_TEMPLATE_FEATURES: ProjectFeature[] = ['delete']
export const GALLERY_TEMPLATE_FEATURES: ProjectFeature[] = []

// A template is a project, so it is drawn with the dashboard's project card.
export const toProjectItem = (
  template: TemplateItem,
  features: ProjectFeature[]
): ProjectItem => ({
  id: template.id,
  title: template.name,
  theme: template.theme,
  updatedAt: template.updatedAt,
  createdAt: template.createdAt,
  thumbnail: template.thumbnail,
  teamId: null,
  sharedBy: null,
  archived: false,
  folderId: null,
  published: false,
  features,
  type: 'sitemap',
  template: true,
})
